import { Switch, Route, Redirect, useHistory, useRouteMatch } from "react-router-dom";
import { useContext, useEffect } from "react";
import AdminContentLayout from "../../layouts/AdminContentLayout";
import dataConstants from "../../constants/dataConstants";
import InfoSliderDispatcher from "../../components/molecular/InfoSliderDispatcherButton";
import Button from "../../components/organism/Button";
import { ApplicationState } from "../../services/context/ApplicationStateContext";
import NotificationsTabNav from "../../components/CommunicationPreferences/NotificationsTabNav";
import CsPreferencesUpdatedBanner from "../../components/CommunicationPreferences/CsPreferencesUpdatedBanner";
import NotificationsInboxPage from "./NotificationsInboxPage";

function NotificationsLayout(): JSX.Element {
  const history = useHistory();
  const match = useRouteMatch();
  const { dispatch } = useContext(ApplicationState);

  useEffect(() => {
    dispatch({ type: "RESET_NOTIFICATION_COUNT" });
  }, [dispatch]);

  function navigateToSettings() {
    history.push("/access/notifications/settings/my-preferences");
  }

  return (
    <AdminContentLayout
      pageTitle="Notifications | CSTL"
      subHeaderTitle="Notifications"
      customButtons={[
        {
          buttonTheme: "transparent",
          textInformation: {
            text: "My preferences",
            fontWeight: "font-normal",
          },
          className: "md:mx-5 mx-3 capitalize",
          onClick: navigateToSettings,
        },
      ]}
    >
      <div className="overflow-visible h-[100vh]">
        <div className="py-6 md:px-5 px-3 bg-white">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <p className="font-bold md:text-2xl text-xl font-royalBlue">
                Notifications
              </p>
              <InfoSliderDispatcher
                infoQuery={dataConstants.infoSliderQuery.notifications}
              />
            </div>
            <Button
              type="button"
              buttonTheme="transparent"
              textInformation={{
                text: "My preferences",
                fontWeight: "font-normal",
                fontSize: "md:text-base text-sm",
              }}
              className="block md:hidden ml-3 capitalize text-left w-full"
              onClick={navigateToSettings}
            />
          </div>
        </div>

        <CsPreferencesUpdatedBanner />
        <NotificationsTabNav />

        <Switch>
          <Route exact path={match.path} component={NotificationsInboxPage} />
          <Route
            path={`${match.path}/digest`}
            render={() => <Redirect to={match.path} />}
          />
        </Switch>
      </div>
    </AdminContentLayout>
  );
}

export default NotificationsLayout;
